/**
 * 判断是否为网络错误
 * @param error 错误对象
 * @returns 是否为网络错误
 */
import { isApp } from './bridge'
import { useAppStore } from '@/stores/app'
import { getSearchParam } from '@/utils/urlQuery'
export const isNetworkError = (error: unknown): boolean => {
  const errorMessage = (error as Error)?.message || ''
  const errorCode = (error as { code?: string })?.code || ''

  return (
    !navigator.onLine ||
    errorMessage.includes('Network Error') ||
    errorMessage.includes('Failed to fetch') ||
    errorMessage.includes('网络') ||
    errorMessage.includes('timeout') ||
    errorCode === 'ECONNABORTED' ||
    errorCode === 'ERR_NETWORK' ||
    errorCode === 'ETIMEDOUT'
  )
}

/**
 * 通用字符串脱敏工具
 *
 * @param {string | number} value - 需要脱敏的原始字符串
 * @param {Object} options - 配置项
 * @param {number} options.head - 保留开头字符数
 * @param {number} options.tail - 保留结尾字符数
 * @param {string} options.mask - 掩码字符
 */
export function maskString(
  value: string | number = '',
  options = { head: 3, tail: 4, mask: '*' },
): string {
  if (!value) return ''

  const str = String(value)
  const { head, tail, mask } = options
  const len = str.length

  if (head + tail >= len) return str

  const masked = mask.repeat(len - head - tail)

  return `${str.slice(0, head)}${masked}${str.slice(-tail)}`
}
export function getSourceType(): string {
  try {
    // App 环境直接返回 ''
    if (isApp()) {
      return ''
    }

    // H5 环境：从 URL 参数获取 source
    const urlSource = getSearchParam('source')

    if (urlSource) {
      console.log(`[Request] 从 URL 获取 source: ${urlSource}`)
      return urlSource.toLowerCase()
    }

    // 没有 source 参数，返回空字符串
    return ''
  } catch (error) {
    console.error('[Request] 获取 sourceType 失败:', error)
    return ''
  }
}
// 封装下 函数 h5获取 deviceType
export function getDeviceType(): string {
  if (isApp()) {
    const appStore = useAppStore()
    const deviceInfo = appStore.getDeviceInfo()

    return deviceInfo?.deviceType || ''
  }

  const userAgent = navigator.userAgent
  console.info('userAgent---》', userAgent)
  const isWechat = /MicroMessenger/i.test(userAgent)
  const isHarmonyOS = /HarmonyOS|OpenHarmony|ArkWeb/i.test(userAgent)
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent)
  const isAndroid = userAgent.includes('Android')
  const sourceType = getSourceType()

  if (sourceType === 'dongcha') {
    if (isWechat) {
      if (isHarmonyOS) return 'dongcha-wechat-harmonyos'
      if (isAndroid) return 'dongcha-wechat-android'
      if (isIOS) return 'dongcha-wechat-ios'
      return 'dongcha-wechat'
    }
    if (isHarmonyOS) return 'dongcha-harmonyos'
    if (isAndroid) return 'dongcha-android'
    if (isIOS) return 'dongcha-ios'
    return 'dongcha-h5'
  }

  if (isWechat) {
    if (isHarmonyOS) return 'wechat-harmonyos'
    if (isAndroid) return 'wechat-android'
    if (isIOS) return 'wechat-ios'
    return 'wechat'
  }

  if (isHarmonyOS) return 'harmonyos'
  if (isAndroid) return 'android'
  if (isIOS) return 'ios'

  return 'unknown'
}
